/**
 * The CLI version shown in the banner + `--version`. Kept in `src` (tsconfig
 * rootDir is `src`, so we cannot import the root package.json without a
 * typecheck error). KEEP THIS IN SYNC WITH `package.json` "version" on every
 * release (the publish step bumps both). `version.test.ts` asserts they match,
 * so a drift fails CI (it previously drifted to 0.3.4 while package.json was 0.6.0,
 * so `aethereum --version` printed the wrong number for a globally-installed CLI).
 */
export const VERSION = "0.6.1";
